import React, { useEffect, useRef } from "react";
import { Send } from "lucide-react";

interface WizardInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  isProcessing: boolean;
  isBotTyping: boolean;
  inputType?: React.HTMLInputTypeAttribute;
  autoComplete?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  placeholder?: string;
  /** id do <label> associado (acessibilidade) */
  labelId?: string;
  showTopBorder?: boolean;
}

export const WizardInput: React.FC<WizardInputProps> = ({
  value,
  onChange,
  onSubmit,
  isProcessing,
  isBotTyping,
  inputType = "text",
  autoComplete,
  inputMode,
  placeholder = "Digite sua resposta...",
  labelId,
  showTopBorder = true,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Foca o input quando o componente é montado
    if (inputRef.current && !isProcessing && !isBotTyping) {
      inputRef.current.focus();
    }
  }, [isProcessing, isBotTyping]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div
      className={`${showTopBorder ? "border-t border-gray-200 dark:border-gray-700" : ""} bg-white dark:bg-gray-800 p-3 md:p-4`}
    >
      <div className="flex gap-2 min-h-[44px]">
        <input
          ref={inputRef}
          id={labelId}
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          autoComplete={autoComplete}
          inputMode={inputMode}
          className="flex-1 min-h-[44px] px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          disabled={isProcessing || isBotTyping}
        />
        <button
          type="button"
          onClick={onSubmit}
          disabled={!value.trim() || isProcessing || isBotTyping}
          className="min-h-[44px] min-w-[44px] p-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
          aria-label="Enviar mensagem"
        >
          <Send size={20} />
        </button>
      </div>
    </div>
  );
};
